import * as Sentry from '@sentry/react';

// Get Sentry DSN from environment variable
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (!SENTRY_DSN) {
  console.warn('VITE_SENTRY_DSN is not set. Sentry will not be initialized.');
} else {
  console.log(
    `Sentry DSN is set. Initializing Sentry for environment: ${import.meta.env.MODE}`
  );
}

// Initialize Sentry
Sentry.init({
  dsn: SENTRY_DSN,

  // Performance monitoring
  tracesSampleRate: 0.1, // 10% of transactions

  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],

  // 100% of sessions in production, 0% in development
  replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 1.0 : 0.0,
  replaysOnErrorSampleRate: 1.0,

  // Set environment
  environment: import.meta.env.MODE || 'development',

  // Enable debug mode in development
  debug: import.meta.env.DEV,

  // Configure beforeSend to filter out certain errors if needed
  beforeSend(event) {
    // Filter out certain errors if needed
    // For example, you might want to filter out network errors
    if (event.exception) {
      const exception = event.exception.values?.[0];
      if (exception?.type === 'NetworkError') {
        return null; // Don't send network errors
      }
    }
    return event;
  },
});

export default Sentry;
